module.exports = __webpack_public_path__ + "img/39_69.c517780b.png";